import React, { useEffect, useState } from 'react';
import ReactTooltip from "react-tooltip";
import { CircularProgress } from '@mui/material';
import { useStyles } from './style';
import LcIconLink from '../LcIconLink';

type Position = "Left" | "Center" | "Right";
type PositionSide = "Left" | "Right";

interface Fields {
    propSubvalue?: React.CSSProperties;
    subValue?: string;
    text: string,
    value: string,
    propText?: React.CSSProperties,
    propValue?: React.CSSProperties,
}

interface Props {
    content?: React.ReactNode,
    position?: Position,
    details?: Function,
    fields?: Fields[],
    expandedFields?: Fields[],
    searchExpandedFields?: Function,
    tooltipId?: string,
    delayHide?: number,
    delayShow?: number,
    delayUpdate?: number,
    noOpacity?: boolean,
    rowId?: string,
    expandPosition?: PositionSide,
    expandNoResults?: string,
    mousePosition?: { x: number, y: number },
    attendant?: boolean,
    hide?: boolean,
    hideAllTooltips?: boolean,
}

const HHDetailTooltip: React.FC<Props> = (props) => {
    const classes = useStyles();
    const [open, setOpen] = useState<boolean>(false);
    const [expandedFields, setExpandedFields] = useState<Fields[]>();
    const [loading, setLoading] = useState<boolean>(false);
    const [expandPosition, setexpandPosition] = useState<PositionSide>("Right")

    const handleClick = async () => {
        setLoading(true);
        setOpen(!open)

        if (!open) {
            props.rowId && props.searchExpandedFields && await props.searchExpandedFields(props.rowId, setExpandedFields);
        }
        else {
            setExpandedFields([]);
        }

        setLoading(false);
    }

    const handleLeave = () => {
        setExpandedFields([]);
        setOpen(false);
    }

    // function getClassPosition(position: Position) {
    //     switch (position) {
    //         case "Right": return classes.DetailsToolTipBodyRight;
    //         case "Center": return classes.DetailsToolTipBodyCenter;
    //         case "Left": return classes.DetailsToolTipBodyLeft;

    //         default: return classes.DetailsToolTipBodyCenter;
    //     }
    // }

    const positionMapping: Record<Position, string> = {
        "Right": classes.DetailsToolTipBodyRight,
        "Center": classes.DetailsToolTipBodyCenter,
        "Left": classes.DetailsToolTipBodyLeft,
    };

    const getClassPosition = (position: Position) => {
        return positionMapping[position] || classes.DetailsToolTipBodyCenter;
    }

    // function getIconPosition(position: PositionSide) {
    //     switch (position) {
    //         case "Right": return (!open) ? "ppi ppi-chevron-right" : "ppi ppi-chevron-left";
    //         case "Left": return (!open) ? "ppi ppi-chevron-left" : "ppi ppi-chevron-right";

    //         default: return (!open) ? "ppi ppi-chevron-right" : "ppi ppi-chevron-left";
    //     }
    // }

    const iconPositions: Record<PositionSide, string> = {
        "Right": (!open) ? "ppi ppi-chevron-right" : "ppi ppi-chevron-left",
        "Left": (!open) ? "ppi ppi-chevron-left" : "ppi ppi-chevron-right",
    };

    const getIconPosition = (position: PositionSide) => {
        return iconPositions[position] || "ppi ppi-chevron-right";
    }


    useEffect(() => {
        let position: PositionSide = "Right";

        if (props.attendant && props.attendant === true) {
            position = (props.mousePosition && props.mousePosition.x < 600) ? "Right" : "Left";
        }
        else {
            position = (props.mousePosition && props.mousePosition.x < 1000) ? "Right" : "Left";
        }

        setexpandPosition(position);
    }, [props.mousePosition])

    const calculateNewPosition = () => {
        let topValue: number;
        let leftValue: number

        if (!props.mousePosition) return { top: 0, left: 0 };

        if (props.mousePosition.y < 290) {
            topValue = props.mousePosition?.y + 10;
        }
        else if (props.mousePosition.y > 290 && props.mousePosition.y < 380) {
            topValue = (props.attendant && props.attendant === true) ? props.mousePosition.y - 50 : props.mousePosition.y + 10;
        }
        else {
            topValue = (props.attendant && props.attendant === true) ? props.mousePosition.y - 380 : props.mousePosition.y - 165;
        }

        if (props.mousePosition.x < 550) {
            leftValue = (props.attendant && props.attendant === true) ? 180 : props.mousePosition.x;
        }
        else if (props.mousePosition.x > 550 && props.mousePosition.x < 610) {
            leftValue = (props.attendant && props.attendant === true) ? props.mousePosition.x + 350 : props.mousePosition.x;
        }
        else if (props.mousePosition.x > 610 && props.mousePosition.x < 670) {
            leftValue = (props.attendant && props.attendant === true) ? props.mousePosition.x + 280 : props.mousePosition.x;
        }
        else if (props.mousePosition.x > 670 && props.mousePosition.x < 750) {
            leftValue = (props.attendant && props.attendant === true) ? props.mousePosition.x + 200 : props.mousePosition.x
        }
        else if (props.mousePosition.x > 750 && props.mousePosition.x < 820) {
            leftValue = (props.attendant && props.attendant === true) ? props.mousePosition.x + 50 : props.mousePosition.x
        }
        else {
            leftValue = (props.attendant && props.attendant === true) ? props.mousePosition.x : props.mousePosition.x - 150
        }

        const newPosition = {
            top: topValue,
            left: leftValue
        };

        return newPosition;
    };

    return (
        <>
            {
                !props.hideAllTooltips && props.hide &&
                <ReactTooltip
                    id={props.tooltipId}
                    delayHide={props.delayHide || 50}
                    delayShow={props.delayShow || 50}
                    delayUpdate={props.delayUpdate || 50}
                    backgroundColor={"transparent"}
                    className={(props.noOpacity) ? classes.DetailsToolTipNoOpacity : ""}
                    place={"left"}
                    effect="solid"
                    overridePosition={calculateNewPosition}
                >
                    <div key={props.tooltipId} className={classes.DetailsToolTip} onMouseLeave={() => handleLeave()}>
                        {props.children}
                        {
                            <div className={props.position && getClassPosition(props.position)}>
                                <div className={classes.DetailsToolTipBodyContent}>
                                    <div onClick={handleClick} className={(props.expandPosition && props.expandPosition === "Left") ? classes.DetailsToolTipIconPositionLeft : classes.DetailsToolTipIconPositionRight}>
                                        {/* <i className={props.expandPosition && getIconPosition(expandPosition)} style={{ color: "black" }} /> */}
                                        <LcIconLink
                                            color={"black"}
                                            size={"small"}
                                            icon={props.expandPosition ? getIconPosition(expandPosition) : ""}
                                            tooltip={!open ? "Abrir comentários" : "Fechar comentários"}
                                            activedAfterClick={open}	
                                        />
                                    </div>
                                    <div className={props.expandPosition && props.expandPosition === "Left" ? classes.DetailsToolTipFieldsLeft : classes.DetailsToolTipFieldsRight}>
                                        {
                                            props.fields &&
                                            props.fields.map((campo, index) => {

                                                return (
                                                    <div key={index} className={classes.DetailsToolTipDivOrderFields}>
                                                        {
                                                            (campo.subValue || campo.text) &&
                                                            <span className={classes.DetailsToolTipFieldsText} style={{ ...campo.propText }}> {campo.text} <span style={{ ...campo.propSubvalue }}>{campo.subValue}</span></span>
                                                        }
                                                        {
                                                            campo.value &&
                                                            <span className={classes.DetailsToolTipFieldsValue} style={{ ...campo.propValue }}> {campo.value} </span>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                        {
                                            open &&
                                            <div className={classes.DetailsToolTipExpand && classes.DetailsToolTipBody && (expandPosition === "Left") ? classes.DetailsToolTipExpandLeft : classes.DetailsToolTipExpandRight}>
                                                {
                                                    !loading
                                                        ? <div className={(expandedFields && expandedFields.length > 0) ? classes.DetailsToolTipBodyContentExpandWithFields : classes.DetailsToolTipBodyContentExpandWithoutFields}>
                                                            {
                                                                expandedFields && expandedFields.length > 0

                                                                    ? expandedFields.map((campo, index) => {

                                                                        return (
                                                                            <div key={index} className={classes.DetailsToolTipDivOrderExpandedFields}>
                                                                                <span className={classes.DetailsToolTipExpandedFieldsValue} style={{ ...campo.propValue }}> {campo.value} </span>
                                                                                <span className={classes.DetailsToolTipExpandedFieldsText} style={{ ...campo.propText }}> {campo.text} </span>
                                                                            </div>
                                                                        )
                                                                    })
                                                                    : <span className={classes.DetailsToolTipSpanExtra}> {props.expandNoResults} </span>
                                                            }
                                                        </div>
                                                        : <div className={classes.DetailsToolTipDivOrderLoading}>
                                                            <span className={classes.DetailsToolTipSpanExtra}> Carregando </span>
                                                            <CircularProgress className={classes.DetailsToolTipCircular} />
                                                        </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </ReactTooltip>
            }
        </>
    );
}

//export const HHDetailTooltip = React.memo(HHDetailTooltipBase);
export default HHDetailTooltip